<template id="ComplianceSettings">
  <section>
    <b-card bg-variant="light">
      <div v-if="settings">
        <b-form>
          <b-row>
            <b-col cols="6">
              <b-form-group
                id="fieldset-1"
                description="Path to security file valid for this repo"
                label="Security File"
                label-for="input-1"
              >
                <b-form-select
                  id="input-1"
                  v-model="settings.secuirtyFile"
                  :options="security"
                  trim
                  :disabled="!edit"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                id="fieldset-2"
                description="Path to license file valid for this repo"
                label="License File"
                label-for="input-2"
              >
                <b-form-select
                  id="input-2"
                  v-model="settings.licenseFile"
                  :options="licenses"
                  trim
                  :disabled="!edit"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div>
            Additional Options
            <b-form-checkbox
              v-model="settings.requiredReadme"
              name="Require Readme"
              :disabled="!edit"
            >
              Require Readme
            </b-form-checkbox>
            <b-form-checkbox
              v-model="settings.disableIssues"
              name="Disable Issues"
              :disabled="!edit"
            >
              Disable Issues
            </b-form-checkbox>
          </div>
        </b-form>
        <div id="formControl">
          <b-button v-if="!edit" variant="primary" @click="editSettings">
            Edit
          </b-button>
          <b-button v-else variant="outline-secondary" @click="cancelChanges">
            Cancel
          </b-button>
          <b-button
            variant="danger"
            v-if="deleteSettings && edit"
            v-on:click="removeSettings"
          >
            Remove
          </b-button>
          <b-button variant="primary" v-if="edit" v-on:click="saveSettings">
            Save
          </b-button>
        </div>
      </div>
      <div v-else>
        Unable to retrieve existing settings.
      </div>
    </b-card>
  </section>
</template>

<script>
export default {
  name: "ComplianceSettings",
  props: {
    settings: Object,
    updateSettings: { type: Function, required: true },
    deleteSettings: Function,
  },
  data() {
    return {
      edit: false,
      settingsCopy: null,
      licenses: [],
      security: [],
    };
  },
  mounted() {
    this.getFiles();
  },
  methods: {
    editSettings() {
      this.settingsCopy = Object.assign({}, this.settings);
      this.edit = true;
    },
    cancelChanges() {
      this.settings.requiredReadme = this.settingsCopy.requiredReadme;
      this.settings.secuirtyFile = this.settingsCopy.secuirtyFile;
      this.settings.licenseFile = this.settingsCopy.licenseFile;
      this.settings.disableIssues = this.settingsCopy.disableIssues;
      this.edit = false;
    },
    saveSettings() {
      this.updateSettings();
      this.settingsCopy = Object.assign({}, this.settings);
      this.edit = false;
    },
    removeSettings() {
      this.deleteSettings();
      this.edit = false;
    },
    async getFiles() {
      this.licenses = (
        (await this.$client.get("filelist/Licenses")) || []
      ).concat({
        value: "",
        text: "Not Required",
      });
      this.security = (
        (await this.$client.get("filelist/Security")) || []
      ).concat({
        value: "",
        text: "Not Required",
      });
    },
  },
};
</script>

<style lang="scss">
#formControl {
  margin: 10px 0 10px 0;

  button {
    margin-right: 10px;
  }
}
</style>
